<template>
  <div class="root">
    <v-layout row align-start align-content-start>
      <v-flex xs4>
        <div :class="tipo.toLowerCase()">{{tipoText}}</div>
      </v-flex>
      <v-flex xs8>
        <div class="titulo">{{titulo.substring(0,16) + (titulo.length > 16 ? '...' : '')}}</div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    tipo: String,
    titulo: String
  },
  computed: {
    tipoText() {
      return this.tipo == "midia" ? "MÍDIA" : this.tipo.toUpperCase();
    }
  }
};
</script>

<style>
.root {
  width: 233px;
  height: 36px;
}
.titulo {
  border: solid 0.5px #707070;
  background-color: #f7f8f2;
}
.midia {
  background-color: #27d9e0;
}
.pergunta {
  background-color: #c327e0;
}
.geral {
  background-color: #35e027;
}
</style>




// WEBPACK FOOTER //
// src/components/charts/ChartMin.vue